const productColors = () => {
  const productColorsElements = document.querySelectorAll('.color-card') as NodeListOf<HTMLElement>;

  const removeActive = () => {
    [...productColorsElements].forEach((element) => {
      element.classList.remove('color-card--active');
    });
  };

  [...productColorsElements].forEach((element) => {
    element.addEventListener('click', () => {
      // Remove all other active states
      removeActive();

      const currentColor = element.dataset.color as string;
      const yithColors = document.querySelector('.select_box_colorpicker.attribute_pa_kleur') as HTMLElement;
      const allColors = yithColors.querySelectorAll('.select_option_colorpicker') as NodeListOf<HTMLElement>;

      [...allColors].forEach((color, index) => {
        const yithColor = color.dataset.value;
        if (yithColor === currentColor) {
          element.classList.add('color-card--active');
          allColors[index].click();
        }
      });
    });
  });
};

export default productColors;
